<template>
  <div class="seat-plan-container">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="深创投39楼" name="sctz39">
        <sctz39SeatPlan :activeName="activeName" />
      </el-tab-pane>
      <el-tab-pane label="深创投38楼" name="sctz38">
        <sctz38SeatPlan :activeName="activeName" />
      </el-tab-pane>
      <!-- <el-tab-pane label="深圳源政" name="first">
        <szSeatPlan :activeName="activeName" />
      </el-tab-pane> -->
      <el-tab-pane label="西安泰维" name="second">
        <xianSeatPlan :activeName="activeName" />
      </el-tab-pane>
      <!-- <el-tab-pane label="深圳阿里" name="third">
        <szAliSeatPlan :activeName="activeName" />
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
// import szSeatPlan from './szSeatPlan'
// import szAliSeatPlan from './szAliSeatPlan'
import xianSeatPlan from './xianSeatPlan'
import sctz38SeatPlan from './sctz38SeatPlan'
import sctz39SeatPlan from './sctz39SeatPlan'
import '@/utils/rem.js'

export default {
  components: { xianSeatPlan, sctz38SeatPlan, sctz39SeatPlan },
  data() {
    return {
      activeName: 'sctz39'
    }
  }
}

</script>

<style lang="scss" scoped>
.seat-plan-container {
  // margin: -20px;
}
</style>
